import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import styles from '../commentContent/commentContent.module.scss';
import icon_expand from '../../../static/images/expand.png';
import icon_expand_revert from '../../../static/images/expand_revert.png';
import icon_arrow_up from '../../../static/images/arrow_up.png';
import icon_doctor_avatar from '../../../static/images/doctor_avatar.png';
import { Toast } from 'antd-mobile';
import { ApiCore } from '../../../api';
const api = new ApiCore();

function CommentContent(props: any) {

    //设置加载状态
    const [isExpand, setIsExpand] = useState(false);
    const [content, setContent] = useState('');
    const [commentInfos, setCommentInfo] = useState([]);
    const [activeComment, setActiveComment] = useState<any>({});
    const [isUpdate, setIsUpdate] = useState(false);
    const [loadReady, setLoadReady] = useState(false);
    const [userCode, setUserCode] = useState(false);

    useEffect(() => {
        initUserCode();
    }, [])

    useEffect(() => {
        props.subjectCode && getCommentList();
    }, [props.subjectCode])

    const toBack = () => {
        updateChange();
    }

    // 获取用户信息
    const initUserCode = () => {
        let token = sessionStorage.getItem('token');
        if (token) {
            let tokenInfo = JSON.parse(token);
            setUserCode(tokenInfo.userCode);
        }
    }

    // 收缩评论区域
    const toExpand = () => {
        const toVal = !isExpand;
        setIsExpand(toVal);
        props.updateExpand(toVal);
    }

    // 评论内容
    const contentChange = (event: any) => {
        setContent(event.target.value)
    }

    // 修改评论内容
    const toUpdate = (val: any) => {
        setContent(val.content);
        setActiveComment(val);
        updateChange();
    }

    // 切换修改与编辑评论状态
    const updateChange = () => {
        setIsUpdate(!isUpdate);
    }

    // 确认保存评论内容
    const toConfirm = () => {
        api.submitCommentSave({
            content: content,
            subjectCode: props.subjectCode,
            id: activeComment.id
        }).then((res: any) => {
            if (res.code == 0) {
                Toast.success('评论保存成功', 1)
                getCommentList();
            } else {
                Toast.fail(res.message || '评论保存失败', 1)
            }
        });
    }

    // 获取评论列表
    const getCommentList = () => {
        api.GetSubjectComments(props.subjectCode).then((res: any) => {
            if (res.code == 0) {
                setCommentInfo(res.data);
                if (res.data && res.data.length > 0) {
                    setIsUpdate(true);
                }
                setLoadReady(true);
            }
        });
    }

    return (
        <div className={`${styles.commentContent_content}`}>
            {
                !isExpand && 
                <div className={styles.expand} onClick={toExpand}>
                    <span>{isExpand ? '收缩' : '展开'}全部</span>
                    <img src={isExpand ? icon_expand_revert : icon_expand} alt="back" />
                </div>
            }
            <div className={styles.gap}></div>
            {
                loadReady && 
                <>
                {
                    isUpdate ?
                        <div className={styles.user_wrap}>
                        {
                            commentInfos && commentInfos.map((val: any, index) => {
                                return (
                                <div className={styles.user_content} key={index}>
                                    <div className={styles.user_head}>
                                        <img src={icon_doctor_avatar} alt="doctor avatar" />
                                        <div className={styles.user_head_right}>
                                            <div className={styles.user_head_name}>{val.userName}</div>
                                            <div className={styles.user_head_time}>{val.updateTime ? val.updateTime.replace('T', ' ') : val.updateTime}</div>
                                        </div>
                                    </div>
                                    <div className={styles.user_comment_text}>“{val.content}”</div>
                                    {
                                        (userCode === val.createUser) && 
                                        <div className={styles.btn_update_wrapped}>
                                            <div className={styles.btn_confirm} onClick={() => { toUpdate(val) }}>
                                                修改
                                            </div>
                                        </div>
                                    }
                                </div>)
                            })
                        }
                    </div>
                    :
                    <div className={styles.commentContent_wrapped}>
                        <textarea className={styles.textAreaInfo} placeholder='在此处输入您的点评内容' value={content} onChange={(val) => { contentChange(val) }}></textarea>
                        <div className={styles.btn_wrapped} >
                            {
                                commentInfos && commentInfos.length > 0 && 
                                <div className={styles.btn_back} onClick={toBack}>
                                    返回
                                </div>
                            }
                            <div className={styles.btn_confirm} onClick={toConfirm}>
                                确认
                            </div>
                        </div>
                    </div>
                }
                </>
            }
            {
                isExpand &&
                <div className={styles.addAction} onClick={toExpand}>
                    <div className={styles.addSubjectLink}>
                        <div className={styles.addSubjectLeft}>
                            <img src={icon_arrow_up} alt="back" />
                        </div>
                        <div className={styles.addSubjectRight}>
                            <div>收起</div>
                            <div>全部</div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )

}

export default withRouter(CommentContent);